import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import SignIn from '../views/auth/SignIn.vue'

const routes = [
  {
    name: 'SignIn',
    path: PATHS.SIGN_IN,
    component: SignIn,
  },
  {
    name: 'MicrosoftCallBack',
    path: PATHS.MICROSOFT_CALLBACK,
    component: () =>
      import(/* webpackChunkName: "auth" */ '../views/auth/Callback.vue'),
    meta: {},
  },
  {
    name: 'Home',
    path: PATHS.HOME,
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'AdminUsers',
    path: PATHS.ADMIN_USERS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Users.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'AdminBoards',
    path: PATHS.ADMIN_BOARDS,
    component: () =>
      import(/* webpackChunkName: "admin" */ '../views/admin/Boards.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Clients',
    path: PATHS.CLIENTS,
    component: () =>
      import(/* webpackChunkName: "clients" */ '../views/clients/Clients.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistersTickets',
    path: PATHS.REGISTERS_TICKETS,
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ '../views/registers/Tickets.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'RegistersTicketsLinkClients',
    path: PATHS.REGISTERS_TICKETS_LINK_CLIENTS,
    component: () =>
      import(
        /* webpackChunkName: "tickets" */ '../views/registers/TicketsLinkClients.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportsMonthly',
    path: PATHS.REPORTS_MONTHLY,
    component: () =>
      import(/* webpackChunkName: "report" */ '../views/reports/Monthly.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportsAccumulated',
    path: PATHS.REPORTS_ACCUMULATED,
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/reports/Accumulated.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'ReportsProductivity',
    path: PATHS.REPORTS_PRODUCTIVITY,
    component: () =>
      import(
        /* webpackChunkName: "report" */ '../views/reports/Productivity.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Billings',
    path: PATHS.BILLINGS,
    component: () =>
      import(
        /* webpackChunkName: "billing" */ '../views/billings/Billings.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'NotificationsFranchise',
    path: PATHS.NOTIFICATIONS_FRANCHISE,
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '../views/notifications/FranchiseNotifications.vue'
      ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from) => {
  const { isLoggedInEthosTickets } = store.getters

  if (isLoggedInEthosTickets && to.name === 'SignIn') {
    return { name: 'Home' }
  }

  if (to.meta.requiresAuth) {
    if (!isLoggedInEthosTickets && !localStorage.getItem('tokenEthosTickets')) {
      return { name: 'SignIn' }
    }
  }
})

router.afterEach(async (to, from) => {
  if (!store.getters.isLoggedInEthosTickets && to.meta.requiresAuth) {
    await store.dispatch('logout')
    router.push(PATHS.SIGN_IN)
  }
})

export default router
